import { UserForm } from 'modules/administrator/components'
import { useCreateUser } from 'modules/administrator/hooks'
import { BasePage } from '../../../../components'

const pathArray = [
  {
    to: '/home',
    title: 'Início'
  },
  {
    to: '/users',
    title: 'Usuários'
  },

  {
    to: '#',
    title: 'Novo Usuário'
  }
]

export const CreateUserPage = () => {
  const { mutate } = useCreateUser()

  const handleSubmit = (data: any) => {
    const userData = {
      customerId: data?.company?.id,
      function: data?.function?.id,
      description: data?.function?.name,
      username: data.username,
      email: data.email,
      password: data.password,
      productLine: data?.productLine?.id,
      active: data.active.id,
      freights: data?.freights?.map((freight: any) => ({
        freightId: freight?.id
      })),
      pricesTable: data?.priceTables?.map((priceTable: any) => ({
        priceTableId: priceTable?.id
      })),
      salesType: data?.salesTypes?.map((saleType: any) => ({
        saleTypeId: saleType?.id
      })),
      unities: data?.unities?.map((unity: any) => unity?.id),
      responsibles: data?.responsibles?.map((item: any) => item?.id)
    }

    mutate(userData)
  }

  return (
    <BasePage
      title="Novo Usuário"
      pathArray={pathArray}
      backButtonNavigation="/users"
    >
      <UserForm onSubmit={handleSubmit} />
    </BasePage>
  )
}

export default CreateUserPage
